import React, { FC, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ISchedule } from "../../api/getSchedulesAvailable";
import CheckoutContext from "../../context/checkoutContext/checkoutContext";
import getUserData from "../utils/getUserData";
import { BuyDetailsInterface, PersonalDataInterface } from "./CheckoutCommon";
import FinishCheckoutStep from "./FinishCheckoutStep";
import PurchaseDetailsStep from "./PurchaseDetailsStep";

const CheckoutStepper: FC = () => {
	const { checkoutId, rescheduleId } = useParams<{ checkoutId: string; rescheduleId: string }>();
	const [passo, setPasso] = useState<number>(0);
	const [dadosCompra, setDadosCompra] = useState<BuyDetailsInterface>();
	const { skipPayment } = getUserData();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const location = useLocation();
	const context = useContext(CheckoutContext);
	const scheduleInfo = (location.state as ISchedule) || undefined;

	const shouldSkipPaymentStep = skipPayment || !!rescheduleId;

	const changeStepUrl = (step: number) => {
		navigate(
			{
				pathname: location.pathname,
				search: `?step=${step}`,
			},
			{
				state: scheduleInfo,
			},
		);
	};

	const carregaProximoPasso = (payload: PersonalDataInterface | BuyDetailsInterface | null) => {
		if (payload != null) {
			if (passo === 0) {
				const dadosCompra = payload as BuyDetailsInterface;
				const [mes, ano] = dadosCompra.validade.split("/");
				setDadosCompra({ ...dadosCompra, mesValidade: mes, anoValidade: ano });
				if (context.setContext)
					context.setContext({
						dadosCompra: { ...dadosCompra, mesValidade: mes, anoValidade: ano },
					});
			}
		}

		changeStepUrl(passo + 1);
	};

	useEffect(() => {
		const step = searchParams.get("step");
		if (step) {
			if (step == "0") setPasso(shouldSkipPaymentStep ? 1 : 0);
			if (step == "1") setPasso(1);
		}
	}, [searchParams]);

	return (
		<>
			{passo === 0 && <PurchaseDetailsStep purchaseData={dadosCompra} scheduleInfo={scheduleInfo} carregaProximoPasso={carregaProximoPasso} />}
			{passo === 1 && (
				<FinishCheckoutStep scheduleInfo={scheduleInfo} rescheduleId={rescheduleId} checkoutId={checkoutId} purchaseData={dadosCompra} />
			)}
		</>
	);
};

export default CheckoutStepper;
